import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AbstractFormControlComponent } from '../abstract-form-control.component';
import { DistributionPercentFormControl } from './distribution-percent-form-control';

@Component({
  standalone: false,
  selector: 'app-distribution-percent-form-control',
  templateUrl: './distribution-percent-form-control.component.html',
  styleUrls: ['./distribution-percent-form-control.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DistributionPercentFormControlComponent),
      multi: true
    }
  ]
})
export class DistributionPercentFormControlComponent
  extends AbstractFormControlComponent<DistributionPercentFormControl>
  implements ControlValueAccessor
{
  @Input() override parentForm: FormGroup = new FormGroup({});
  @Input() override formControlName: string = undefined;
  @Input() override title: string = undefined;
  onChange: any = (value: string) => {};
  onTouched: any = () => {};

  public registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public writeValue(value: any): void {}
}
